var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "business-metrics" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "impact-section" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(
            _vm.satisfaccionMetrics.impacto_pensionados,
            function (valor, metrica) {
              return _c("div", { key: metrica, staticClass: "col-md-3" }, [
                _c("div", { staticClass: "impact-card" }, [
                  _c("div", { staticClass: "impact-icon" }, [
                    _c("i", { class: _vm.getImpactIcon(metrica) }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "impact-content" }, [
                    _c("div", { staticClass: "impact-value" }, [
                      _vm._v(_vm._s(_vm.formatImpactValue(valor, metrica))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "impact-label" }, [
                      _vm._v(_vm._s(_vm.getImpactLabel(metrica))),
                    ]),
                  ]),
                ]),
              ])
            }
          ),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "efficiency-section" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(
            _vm.satisfaccionMetrics.eficiencia_operativa,
            function (valor, metrica) {
              return _c("div", { key: metrica, staticClass: "col-md-3" }, [
                _c("div", { staticClass: "efficiency-card" }, [
                  _c("div", { staticClass: "efficiency-icon" }, [
                    _c("i", { class: _vm.getEfficiencyIcon(metrica) }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "efficiency-content" }, [
                    _c("div", { staticClass: "efficiency-value" }, [
                      _vm._v(_vm._s(_vm.formatEfficiencyValue(valor, metrica))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "efficiency-label" }, [
                      _vm._v(_vm._s(_vm.getEfficiencyLabel(metrica))),
                    ]),
                    _vm._v(" "),
                    metrica === "roi_sistema"
                      ? _c("div", { staticClass: "efficiency-trend" }, [
                          _c(
                            "span",
                            {
                              staticClass: "trend-indicator",
                              class: _vm.getROITrend(valor),
                            },
                            [
                              _c("i", { class: _vm.getROITrendIcon(valor) }),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.getROITrendText(valor)) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ])
            }
          ),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "indicators-section" }, [
        _vm._m(3),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(
            _vm.satisfaccionMetrics.indicadores_negocio,
            function (valor, indicador) {
              return _c("div", { key: indicador, staticClass: "col-md-3" }, [
                _c("div", { staticClass: "indicator-card" }, [
                  _c("div", { staticClass: "indicator-icon" }, [
                    _c("i", { class: _vm.getIndicatorIcon(indicador) }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "indicator-content" }, [
                    _c("div", { staticClass: "indicator-value" }, [
                      _vm._v(
                        _vm._s(_vm.formatIndicatorValue(valor, indicador))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator-label" }, [
                      _vm._v(_vm._s(_vm.getIndicatorLabel(indicador))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "indicator-status",
                        class: _vm.getIndicatorStatus(valor, indicador),
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.getIndicatorStatusText(valor, indicador)
                            ) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ])
            }
          ),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "roi-analysis" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "roi-card" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "roi-metrics" }, [
                _c("div", { staticClass: "roi-metric" }, [
                  _c("div", { staticClass: "metric-label" }, [
                    _vm._v("ROI del Sistema"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-value" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.satisfaccionMetrics.eficiencia_operativa &&
                          _vm.satisfaccionMetrics.eficiencia_operativa
                            .roi_sistema) ||
                          0
                      ) + "x"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "metric-description" }, [
                    _vm._v(
                      "\n                  Por cada peso invertido, se generan " +
                        _vm._s(
                          (_vm.satisfaccionMetrics.eficiencia_operativa &&
                            _vm.satisfaccionMetrics.eficiencia_operativa
                              .roi_sistema) ||
                            0
                        ) +
                        " pesos en valor\n                "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "roi-comparison" }, [
                  _c("div", { staticClass: "comparison-item" }, [
                    _c("div", { staticClass: "comparison-label" }, [
                      _vm._v("Benchmark del Sector"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "comparison-value" }, [
                      _vm._v(
                        "$" +
                          _vm._s(
                            (_vm.satisfaccionMetrics.eficiencia_operativa &&
                              _vm.satisfaccionMetrics.eficiencia_operativa
                                .benchmark_sector) ||
                              0
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "comparison-item" }, [
                    _c("div", { staticClass: "comparison-label" }, [
                      _vm._v("Costo Actual"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "comparison-value" }, [
                      _vm._v(
                        "$" +
                          _vm._s(
                            (_vm.satisfaccionMetrics.eficiencia_operativa &&
                              _vm.satisfaccionMetrics.eficiencia_operativa
                                .costo_por_solicitud) ||
                              0
                          )
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "opportunities-card" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "opportunities-content" }, [
                _c("div", { staticClass: "opportunity-item" }, [
                  _c("div", { staticClass: "opportunity-label" }, [
                    _vm._v("Ahorro Potencial"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "opportunity-value" }, [
                    _vm._v(
                      _vm._s(
                        (_vm.satisfaccionMetrics.eficiencia_operativa &&
                          _vm.satisfaccionMetrics.eficiencia_operativa
                            .oportunidades_ahorro) ||
                          0
                      ) + "%"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "opportunity-bar" }, [
                    _c("div", {
                      staticClass: "opportunity-progress",
                      style: {
                        width:
                          ((_vm.satisfaccionMetrics.eficiencia_operativa &&
                            _vm.satisfaccionMetrics.eficiencia_operativa
                              .oportunidades_ahorro) ||
                            0) + "%",
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(6),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-chart-line text-success" }),
      _vm._v(" Métricas de Negocio"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-users text-primary" }),
      _vm._v(" Impacto en Pensionados"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-cogs text-warning" }),
      _vm._v(" Eficiencia Operativa"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-chart-bar text-info" }),
      _vm._v(" Indicadores Clave de Negocio"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-calculator text-success" }),
      _vm._v(" Análisis de ROI"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h6", [
      _c("i", { staticClass: "fal fa-lightbulb text-warning" }),
      _vm._v(" Oportunidades de Ahorro"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "savings-breakdown" }, [
      _c("div", { staticClass: "savings-item" }, [
        _c("span", { staticClass: "savings-label" }, [
          _vm._v("Automatización:"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "savings-value" }, [_vm._v("15%")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "savings-item" }, [
        _c("span", { staticClass: "savings-label" }, [
          _vm._v("Optimización de Procesos:"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "savings-value" }, [_vm._v("25%")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "savings-item" }, [
        _c("span", { staticClass: "savings-label" }, [
          _vm._v("Reducción de Errores:"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "savings-value" }, [_vm._v("10%")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }